import { render, staticRenderFns } from "./commonBottom.vue?vue&type=template&id=260af988&scoped=true"
import script from "./commonBottom.vue?vue&type=script&lang=js"
export * from "./commonBottom.vue?vue&type=script&lang=js"
import style0 from "./commonBottom.vue?vue&type=style&index=0&id=260af988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260af988",
  null
  
)

export default component.exports